// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loadingStake_loadingWrapper__21poO","loadingTab":"loadingStake_loadingTab__182rm"};